import { InjectionToken } from "@angular/core";

export const ENV = new InjectionToken("env");
